import { GET_DATA } from '../actions/actions';  // An action creator that instead of returning the action plain object by calling dispatch() method, it returns another function where there should be an async code before dispatching the action
import db from '../../db/db.json';

let initState = {
   books: Object.values(db.books),
   otherProducts: db.otherProducts,
   whatsNew: Object.values(db.whatsNew)
}


function rootReducer(state = initState, action) {
   // if (action.type === GET_DATA) {
   //    return Object.assign({}, state, action.payload);
   // }
   return state;
}

export default rootReducer;